import React from 'react';

function ServicesHomeTwo({ className }) {
    return (
        <>
            <section className={`appie-services-2-area pb-100 ${className}`} id="service">
                <div className="container">
                    <div className="row align-items-end">
                        <div className="col-lg-6 col-md-8">
                            <div className="appie-section-title">
                                <h3 className="appie-title">Why Find Jobs Through Supermedic Health?</h3>
                                <p>
                                Built to empower healthcare professionals to find the best work at anywhere, everywhere.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="200ms"
                            >
                                <div className="icon">
                                    <i className="fas fa-stethoscope" />
                                </div>
                                <h4 className="title">Healthcare-Focused Platform</h4>
                                <p>
                                We focus exclusively on healthcare roles, ensuring every listing is relevant to your profession and career path.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 item-2 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="400ms"
                            >
                                <div className="icon">
                                    <i className="fas fa-briefcase" />
                                </div>
                                <h4 className="title">Full Range of Job Types</h4>
                                <p>
                                From full-time and permanent roles to contract and temporary work, we offer flexible options to suit your lifestyle and goals.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 item-3 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="600ms"
                            >
                                <div className="icon">
                                    <i className="fas fa-shield-alt" />
                                </div>
                                <h4 className="title">Verified Employers Only</h4>
                                <p>
                                All jobs are posted by trusted healthcare organisations, clinics, and hospitals — no random listings, no unknown sources.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 item-4 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="200ms"
                            >
                                <div className="icon">
                                    <i className="fas fa-paper-plane" />
                                </div>
                                <h4 className="title">Easy, Direct Applications</h4>
                                <p>
                                Apply directly to the hiring organisation with no middleman involved. Your application goes straight to the source.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 item-5 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="400ms"
                            >
                                <div className="icon">
                                    <i className="fas fa-list-alt" />
                                </div>
                                <h4 className="title">Simple, Transparent Listings</h4>
                                <p>
                                Every job post includes the essentials — job type, location, hours, and requirements — so you can make informed decisions.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 item-6 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="600ms"
                            >
                                <div className="icon">
                                    <i className="fas fa-graduation-cap" />
                                </div>
                                <h4 className="title">Built for All Career Stages</h4>
                                <p>
                                Whether you're just starting out, in between roles, or looking for your next long-term opportunity, Supermedic Health connects you with what's next.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ServicesHomeTwo;
